
import { Component, Vue } from "vue-property-decorator";
import * as Model from "@gigalot/data-models";
const lodash = require("lodash");
const Subscriber = require("@jetblack/graphql-reconnect-client");
import { createClient } from "@/helpers/graphql-ws-rtc-adapter";

import { EventBus } from "../eventBus";
@Component
export default class MixResults extends Vue {
  search = "";
  loaders: Model.Loader[] = [];
  mixResults: any[] = [];
  rationPlans: Model.RationPlan[] = [];
  rationColorMap: Record<string, string> = {};
  name = "mixResults";
  loading = false;

  get moment() {
    return this.$store.state.moment;
  }

  get tableItems() {
    return (this.mixResults || []).map((mix: any) => {
      const planned = Number(mix?.RationWeightRequired) || 0;
      const actual = Number(mix?.ActualWeight) || 0;
      return {
        ...mix,
        variance: actual - planned,
        rationColor: this.getRationColor(mix?.RationCode),
      };
    });
  }

  getTractorName(guid: string) {
    const tractor = this.loaders.find((loader) => loader.guid === guid);
    if (tractor) {
      return tractor.tractor.electronicID;
    } else return guid;
  }

  headers = [
    {
      text: "Ration",
      value: "RationCode",
      align: "start",
      sortable: true,
      filterable: true,
      divider: true,
    },
    {
      text: "Planned (kg)",
      value: "RationWeightRequired",
      align: "end",
      sortable: true,
      filterable: true,
      divider: true,
    },
    {
      text: "Actual (kg)",
      value: "ActualWeight",
      align: "end",
      sortable: true,
      filterable: true,
      divider: true,
    },
    {
      text: "Variance (kg)",
      value: "variance",
      align: "end",
      sortable: true,
      filterable: false,
      divider: true,
    },
    {
      text: "Tractor",
      value: "TractorID",
      align: "start",
      sortable: true,
      filterable: true,
      divider: true,
    },
    {
      text: "Load Duration",
      value: "LoadDuration",
      align: "center",
      sortable: true,
      filterable: true,
      divider: true,
    },
    {
      text: "Started",
      value: "MixStartTime",
      align: "start",
      sortable: true,
      filterable: true,
      divider: true,
    },
    {
      text: "Completed",
      value: "MixEndTime",
      align: "start",
      sortable: true,
      filterable: true,
    },
  ];

  urlws = "wss://pi.gigalot.systems:7778/api/ws";
  options = {};

  get themeClass(): string {
    return this.$store.state.lightDarkMode;
  }

  graphQLSubscriber: any = undefined;
  graphQLUnsubscribe: any = undefined;

  subscriptions = `subscription($guid:String!){
          mixResults(guid:$guid){
           guid
           MixID
           RationCode
           MixStartTime
           MixEndTime
           RationWeightRequired
           ActualWeight
           TractorID
           LoadDuration
           LoadIngredients {
              MaterialCode
              ActualWeight
              MixSequenceNumber
              FelID
              LoadStartTime
              LoadEndTime
              OperatorID
           }
        }
      }`;

  variables = { guid: this.$store.state.user.location.guid };
  operationName = null;

  mounted() {
    EventBus.$once("component-a-done", this.getMixResults);
    this.$store.dispatch("user/addFirebaseCallback", this.getDataSocket);
    //this.$store.dispatch("user/addFirebaseCallback", this.getMixResults);
    this.loaders = lodash.cloneDeep(this.$store.getters["storage"]().Loaders) as Model.Loader[];
  }

  async getDataSocket() {
    if (this.$store.state.useP2PConn) {
      await this.getOnlineFeedDeliveriesSocket();
    } else {
      await this.getOnsiteFeedDeliveriesSocket();
    }
  }

  async getOnlineFeedDeliveriesSocket() {
    let variables = { guid: this.$store.state.user.location.guid, user: this.$store.state.user.user.uid };

    const subscribe = (subscriptions: string, variables: any, callback: (error: any, data: any) => Promise<void>) => {
      const client = createClient();
      let unsubscribe = client?.subscribe(
        {
          query: subscriptions,
          variables: variables,
        },
        {
          next: (message: any) => callback(undefined, message.data),
          error: (err: any) => {
            throw err;
          },
          complete: () => console.log("subscription completed"),
        }
      );
      return unsubscribe;
    };

    this.graphQLUnsubscribe = subscribe(this.subscriptions, variables, async (error: any, data: any) => {
      this.$store.state.wsConnected = true;
      if (!(error || subscribe)) {
        console.log("subscribe success");
        this.$store.state.wsDialogVisible = false;
        // Normal closure
        return;
      }
      if (error) {
        console.log("error subscribing");

        this.$store.state.wsConnected = false;
        if (error.event.type === "close") {
        } else {
          this.$store.state.wsDialogVisible = true;
          console.error(error);
          //    throw error;
        }
      }
      this.$store.state.wsDialogVisible = false;
      this.$store.state.wsConnected = true;
      console.log("almost there");
      this.mixResults = data.mixResults;
    });
  }

  async getOnsiteFeedDeliveriesSocket() {
    this.graphQLSubscriber = Subscriber.graphQLReconnectingSubscriber(
      this.urlws,
      this.options,
      (error: any, subscribe: any) => {
        try {
          if (!(error || subscribe)) {
            console.log("connected to socket");
            this.$store.state.wsDialogVisible = false;
            return;
          }
          if (error) {
            console.log("error connecting to socket");
            if (error.event.type === "close") {
            } else {
              this.$store.state.wsDialogVisible = true;
              console.error(error);
            }
          }
          console.log("socket connected");
          this.graphQLUnsubscribe = subscribe(this.subscriptions, this.variables, this.operationName, (error: any, data: any) => {
            if (!(error || subscribe)) {
              console.log("subscribe success");
              this.$store.state.wsDialogVisible = false;
              return;
            }
            if (error) {
              console.log("error subscribing");
              if (error.event.type === "close") {
              } else {
                this.$store.state.wsDialogVisible = true;
                console.error(error);
              }
            }
            this.$store.state.wsDialogVisible = false;
            console.log("receiving data");
            this.mixResults = data.mixResults;
            this.loading = false;
          });
        } catch (err) {}
      },
      15000,
      3,
      "graphql-ws"
    );
  }

  async getMixResults() {
    this.loading = true;
    try {
      console.log("getMixingResults()");

      let gql = `query($guid:String!){
          MixResults(guid:$guid){
           guid
           MixID
           RationCode
           MixStartTime
           MixEndTime
           RationWeightRequired
           ActualWeight
           TractorID
           LoadDuration
           LoadIngredients {
              MaterialCode
              ActualWeight
              MixSequenceNumber
              FelID
              LoadStartTime
              LoadEndTime
              OperatorID
           }
        }
        RationPlans(guid:$guid) {
          guid
          rationItems {
            ration
            colour
          }
        }
      }`;
      let json = await this.$store.dispatch("graphQl", {
        gql,
        variables: { guid: this.$store.state.user.location.guid },
        url: "https://pi.gigalot.systems:7777/feeder",
      });
      const results = json?.data?.MixResults ?? [];
      console.log(`Done Downloading Mix Results: ${results.length}`);
      this.mixResults = results;
      this.rationPlans = json?.data?.RationPlans ?? [];
      this.buildRationColorMap();
      this.loading = false;
    } catch (err) {
      console.log("mixResults -> error: " + err);
    }
    EventBus.$emit("component-b-done");
  }

  numberWithCommas(value: number | string) {
    if (value === null || value === undefined || value === "") return "0";
    const numeric = Number(value);
    if (!Number.isFinite(numeric)) return "0";
    return `${Math.round(numeric)}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  formatNumber(value: number | string) {
    return this.numberWithCommas(value);
  }

  formatVariance(value: number) {
    const numeric = Number(value) || 0;
    if (numeric === 0) return "0";
    return `${numeric > 0 ? "+" : "-"}${this.numberWithCommas(Math.abs(numeric))}`;
  }

  varianceClass(value: number) {
    const numeric = Number(value) || 0;
    if (numeric > 0) return "variance--positive";
    if (numeric < 0) return "variance--negative";
    return "variance--neutral";
  }

  normalizeColor(color?: string) {
    if (!color) return "grey darken-1";
    if (typeof color === "string") return color.toLowerCase();
    return `${color}`.toLowerCase();
  }

  buildRationColorMap() {
    const map: Record<string, string> = {};
    this.rationPlans.forEach((plan: Model.RationPlan) => {
      plan?.rationItems?.forEach((item: any) => {
        if (item?.ration && item?.colour) {
          map[item.ration] = item.colour;
        }
      });
    });
    this.rationColorMap = map;
  }

  getRationColor(ration: string) {
    return this.rationColorMap[ration] || "";
  }

  formatTimestamp(value: number | string) {
    const numeric = Number(value);
    if (!Number.isFinite(numeric) || numeric <= 0) return "—";
    return this.moment(numeric).format("HH:mm:ss");
  }
}
